import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectEamEfaDashboardUrls = createSelector(
  (state: GlobalState) => state.eamEfaDashboardUrls,
  (eamEfaDashboardUrls) => eamEfaDashboardUrls,
);
